import { Text } from "@zapier/design-system";
import {
  EdgeProps,
  EdgeLabelRenderer,
  BaseEdge,
  useInternalNode,
} from "@xyflow/react";

import styles from "./CustomEdge.module.css";
import { getSmoothStepPath } from "./smoothstep-edge";

const CustomEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  label,
  markerStart,
  markerEnd,
  sourcePosition,
  targetPosition,
  source,
  target,
}: EdgeProps) => {
  const [edgePath, labelX] = getSmoothStepPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
  });

  // Get internal nodes with access to internals property
  const sourceNode = useInternalNode(source);
  const targetNode = useInternalNode(target);

  // Calculate z-index matching React Flow's getElevatedEdgeZIndex logic
  // This prevents the labels from being behind the edge SVG when inside a group node
  // Bug: https://cdn.zappy.app/ba09f93475d5567f439d0180961dc7d7.png
  // Uses node's internals.z (0 by default, elevated when node or parent is selected)
  // z-index = 0 by default
  // z-index = 1000 when source/target node is selected
  // z-index = 1001 when parent group node is selected
  const edgeZIndex =
    sourceNode && targetNode
      ? Math.max(sourceNode.internals.z, targetNode.internals.z)
      : 0;

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        markerEnd={markerEnd}
        markerStart={markerStart}
      />
      <EdgeLabelRenderer>
        <div
          style={{
            transform: `translate(-50%, -50%) translate(${
              labelX + 40
            }px,${targetY}px)`,
            // Use the exact z-index that React Flow calculates for the edge SVG
            zIndex: edgeZIndex,
          }}
          className={styles.edgeLabel}
        >
          <Text type="SmallPrint3">{label}</Text>
        </div>
      </EdgeLabelRenderer>
    </>
  );
};

export default CustomEdge;
